import { Outlet, useLocation } from "react-router-dom";

import { PageHeader } from "@/lib/components/PageHeader/PageHeader";
import Spinner from "@/lib/components/ui/Spinner";
import { useAuth } from "@/lib/hooks";
import { cn } from "@/lib/utils";
import { redirectToLogin } from "@/lib/router/redirectToLogin";
import { usePageHeaderContext } from "@/lib/context/PageHeaderProvider";

export const AuthGuard = (): JSX.Element => {
  const { isAuthenticated, isLoading } = useAuth();
  const { config } = usePageHeaderContext();
  const { pathname } = useLocation();
  const isHomePage = pathname === "/";

  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Spinner
          className={cn("text-4xl", isHomePage ? "text-white" : "text-primary")}
        />
      </div>
    );
  }

  if (!isAuthenticated) {
    redirectToLogin();

    return <></>;
  }

  return (
    <>
      <PageHeader {...config} />
      <Outlet />
    </>
  );
};
